<template>
  <div class="product-list-item list-item" :class="{
    'zero-quantity': quantity <= 0,
    'positive-quantity': quantity > 0,
    'shows-total': showTotal,
  }" v-if="product">

    <div class="list-item-content">
      <h3 class="list-item-name">{{ services.translations.translation2Text(product.name) }}</h3>
      <div class="list-item-description"
        v-if="services.translations.translation2Text(product.description) && hasDescription == true"
        v-safe-html="services.translations.translation2Text(product.description)">
      </div>
      <!-- role="text" makes VoiceOver read the split label + value ("Available units: 3", or the
           out-of-stock message) as one coherent phrase instead of separate, easily-missed items.
           It's a VoiceOver coalescing role; other screen readers ignore it and read as before. -->
      <div class="stock-info-container" role="text" aria-hidden="true"
          :class="{ 'outofstock': remainingItemsInStock < 1, 'low': remainingItemsInStock < 5 }" v-if="showStockInfo">
          <span class="label" v-if="remainingItemsInStock > 0" v-text="$t('order-item-remaining-stock') + ': '"></span>
          <span class="value" v-if="remainingItemsInStock > 0" v-text="remainingItemsInStock"></span>
          <span class="label" v-if="remainingItemsInStock <= 0" v-text="$t('product-out-of-stock-label')"></span>
        </div>


      <div class="combined" v-if="isCombinedProduct">
        <div class="combined-products">
          <div class="preview">
            <div class="slot" v-for="slot of slots" :key="slot.id">
              <span class="slotname" v-text="services.translations.translation2Text(slot.name) + ':'"></span>
              <div class="product">
                <span class="productname" v-text="translatedProductName(item.chosen[slot.id])"></span>
              </div>
            </div>
          </div>
        </div>
      </div>




      <div class=" options" v-if="hasOptionsSelected">
        <div class="options">
          <div class="preview">
            <span class="cart-options-label" v-text="$t('shopping-cart-options-label')"
              v-if="false && selectedOptions.length > 0"></span>
            <div class="option" v-for="option, optionIndex of selectedOptions" :key="option.id">
              <span class="optionname" v-text="services.translations.translation2Text(option.name)"></span>:
              <span class="optionvalues">
                <span class="optionvalue" v-for="(val, valIndex) of option.values" :key="(val && val.id) || valIndex"
                  v-text="services.translations.translation2Text(val.name)"></span>
              </span>              
            </div>
          </div>

        </div>
      </div>

      <div class="tags" v-if="tags && tags.length > 0">
        <div class="tag" v-for="tag of tags" :key="tag" v-text="services.translations.translation2Text(tag.name)"
          :style="{ 'background-color': tag.color + 'dd' }"></div>
      </div>
      <div class="note-buttons" v-if="withNote && !readonly">
        <ion-button class="note-button add" fill="clear" @click="addNote" v-if="!showNote && !comment"> {{ $t('order-item-add-note')
        }} </ion-button>
        <ion-button class="note-button remove" fill="clear" @click="removeNote" v-if="showNote || comment"> {{
          $t('order-item-remove-note') }}
        </ion-button>
      </div>


    </div>

    <div class="list-item-actions quantity" v-if="readonly">
      <div class="list-item-quantity">
        <span class="quantity" v-text="quantity"></span>
        <span class="times">x</span>
      </div>
    </div>

    <div class="list-item-actions price" v-if="readonly && price">
      <div class="list-item-price">{{ Number.parseFloat(price).toFixed(2) }}<span class="currency-symbol"
          v-text="currencySymbol"></span></div>
    </div>


    <div class="list-item-actions price-quantity" v-if="!readonly">
      <div class="list-item-price" v-if="price">{{ Number.parseFloat(price).toFixed(2) }}<span class="currency-symbol"
          v-text="currencySymbol"></span></div>


      <div class="quantity-input" v-if="company.isOpen && !pointofsale.closed">
        <ion-button class="count-button down" fill="clear" @click="countCartItemDown"
          :aria-label="$t('product-quantity-decrease-aria-label')">
          <ion-icon slot="icon-only" :icon="removeOutline"></ion-icon>
        </ion-button>
        <span class="quantity" v-text="quantity"></span>
        <ion-button class="count-button up" fill="clear" @click="countCartItemUp"
          :aria-label="$t('product-quantity-increase-aria-label')"
          :disabled="((remainingItemsInStock !== null) && (remainingItemsInStock <= 0)) || (combinedSubproductHeadroom !== null && combinedSubproductHeadroom <= 0)"><ion-icon slot="icon-only" :icon="addOutline"></ion-icon>
        </ion-button>
      </div>
      <div class="count-up-disabled-hint" v-if="combinedSubproductHeadroom !== null && combinedSubproductHeadroom <= 0"
        v-text="$t('cart-item-combined-subproduct-out-of-stock-hint')"></div>
    </div>
    <div class="list-item-actions total" v-if="showTotal">
      <div class="list-item-total" v-if="price">
        {{ Number.parseFloat(price * quantity).toFixed(2) }}<span class="currency-symbol"
          v-text="currencySymbol"></span>
      </div>
    </div>
    <div class="list-item-actions note below" v-if="withNote && !readonly && (showNote || comment)">
      <textarea auto-grow outlined rows="1" :label="$t('shopping-cart-input-label-item-note')"
        v-model="comment"></textarea>
    </div>

    <div class="list-item-actions note below readonly-note" v-if="(readonly || !withNote) && item.note">
      <div class="note-text" v-text="item.note"></div>
    </div>

  </div>
</template>

<script setup>
import { IonButton, IonIcon } from "@ionic/vue";
import { addOutline, removeOutline } from "ionicons/icons";

</script>

<script>


// + ' ' + (remainingItemsInStock > 1 ? $t('order-item-remaining-stock-piece-plural') : $t('order-item-remaining-stock-piece-singular'))

export default {
  props: ["item", "table", "showTotal", "withNote", "hasDescription", "cartItem", "readonly"],
  data() {
    return {
      showNote: false,
      comment: "",
      chosenProducts: {}
    }
  },
  watch: {
    comment: function () {
      //write the note onto THIS cart line (matched by id), only while editing is enabled
      if (this.withNote) {
        this.services.cartService.changeNote(this.item, this.comment);
      }
    },
    item: function () {
      //keep the local note in sync when the cart line is refreshed (itemsInCart returns new copies)
      let note = this.item && this.item.note ? this.item.note : "";
      if (note != this.comment) {
        this.comment = note;
      }
    },
  },
  computed: {
    price() {
      if (!this.product) {
        return 0
      }
      let productPriceWithCorrections = Number.parseFloat(this.product.price)

      if (this.selectedOptions) {
        for (let option of this.selectedOptions) {
          for (let val of (option.values || [])) {
            if (val && val.correction && Number.parseFloat(val.correction)) {
              productPriceWithCorrections += Number.parseFloat(val.correction);
            }
          }
        }
      }

      if (this.product.type == 'combined' && this.product.slots && this.product.slots.length > 0) {
        for (let slot of this.product.slots) {
          let productId = this.item.chosen[slot.id] ? this.item.chosen[slot.id] : null;
          if (productId && slot.availableProducts[productId] && slot.availableProducts[productId].correction) {
            if (slot.availableProducts[productId].correction) {
              productPriceWithCorrections += Number.parseFloat(slot.availableProducts[productId].correction)
            }
          }
        }
      }



      return Number.parseFloat(productPriceWithCorrections)
    },
    isCombinedProduct() {
      return this.product && (this.product.type == 'combined')
    },
    hasDetails() {
      return this.isCombinedProduct
    },
    showStockInfo() {
      return this.pointofsale && this.pointofsale.showRemainingStockNumbers && !Number.isNaN(Number.parseInt(this.product.numberOfItemsInStock))
    },
    //Headroom left after accounting for everything already in the cart (variant
    //lines, combined-product slot picks). Null if the product doesn't track stock.
    remainingItemsInStock() {
      if (!this.product) return null
      let stock = Number.parseInt(this.product.numberOfItemsInStock)
      if (Number.isNaN(stock)) return null
      let inCart = this.services.cartService.getTotalQuantityForProductId(this.product.id)
      return Math.max(0, stock - inCart)
    },
    //For combined products with stockOfSubproductsAffectCombinedProduct on, the
    //ceiling on this cart line's quantity is also bounded by every chosen
    //subproduct's stock. Returns the headroom for ADDING one more unit on top
    //of this line's current quantity (cart aggregate already includes this
    //line's consumption of each sub). Null when the gate doesn't apply.
    combinedSubproductHeadroom() {
      if (!this.product || this.product.type != 'combined') return null
      if (!this.product.stockOfSubproductsAffectCombinedProduct) return null
      if (!this.item || !this.item.chosen) return null

      let chosenCounts = {}
      for (let slotId in this.item.chosen) {
        let id = this.item.chosen[slotId]
        if (!id) continue
        chosenCounts[id] = (chosenCounts[id] || 0) + 1
      }

      let minHeadroom = null
      for (let chosenId in chosenCounts) {
        let chosen = this.services.company.getProductById(chosenId)
        if (!chosen) continue
        let stock = Number.parseInt(chosen.numberOfItemsInStock)
        if (Number.isNaN(stock)) continue
        let inCart = this.services.cartService.getTotalQuantityForProductId(chosenId)
        let perMenu = chosenCounts[chosenId]
        let headroom = Math.floor(Math.max(0, stock - inCart) / perMenu)
        if (minHeadroom === null || headroom < minHeadroom) {
          minHeadroom = headroom
        }
      }
      return minHeadroom
    },
    hasOptionsSelected() {
      return this.item && this.item.options && Object.keys(this.item.options).length > 0
    },
    selectedOptions() {
      if (this.isCombinedProduct) {
        return [];
      }

      if (!this.product) {
        return [];
      }
      if (!this.product.options) {
        return [];
      }

      let options = JSON.parse(JSON.stringify(this.product.options));
      let selectedOptions = []

      if (this.item.options) {
        for (let optionId in this.item.options) {
          let raw = this.item.options[optionId]
          let valueIds = Array.isArray(raw) ? raw : (raw ? [raw] : [])
          if (valueIds.length === 0) continue

          for (let option of options) {
            if (option.id == optionId) {
              let values = []
              for (let valueId of valueIds) {
                for (let possibleValue of option.possibleValues) {
                  if (possibleValue.id == valueId) {
                    values.push(possibleValue)
                  }
                }
              }
              if (values.length === 0) continue
              selectedOptions.push({
                id: option.id,
                name: option.name,
                correction: option.correction,
                values
              })
              break;
            }
          }


        }


      }

      return selectedOptions;
    },
    slots() {
      if (!this.isCombinedProduct) {
        return [];
      }

      let slots = JSON.parse(JSON.stringify(this.product.slots));

      let validSlots = [];
      for (let slot of slots) {
        if (!slot.availableProducts) {
          continue
        }
        let products = [];
        for (let productLine of Object.values(slot.availableProducts)) {
          if (productLine.hidden) { continue }

          let product = productLine.productId ? this.services.company.getProductById(productLine.productId) : null;
          if (!product) { continue }

          products.push(product);
        }
        slot.products = products;

        if (slot.products.length < 1) {
          continue
        }
        validSlots.push(slot);
      }
      return validSlots;
    },
    quantity() {
      if (!this.product) {
        return 0;
      }
      return this.services.cartService.getQuantityForProduct(this.item);
    },
    product() {
      if (!this.item || !this.item.productId) {
        return null;
      }
      return this.services.company.getProductById(this.item.productId)
    },


    tags() {
      let tags = [];
      if (!this.product.tags || this.product.tags.length <= 0) {
        return tags;
      }
      for (let tag of this.company.tags) {
        if (this.product.tags.includes(tag.id)) {
          tags.push(tag);
        }
      }
      return tags;
    },
  },
  async mounted() {
    this.comment = this.item && this.item.note ? this.item.note : "";
  },
  methods: {
    translatedProductName(productId) {
      if (!productId) {
        return ''
      }
      let product = this.services.company.getProductById(productId);
      if (!product) {
        return ''
      }
      return this.services.translations.translation2Text(product.name)
    },
    countCartItemDown() {
      this.services.cartService.countCartItemDown(this.item);
    },
    countCartItemUp() {
      this.services.cartService.countCartItemUp(this.item);
      //if this increase used up the last available unit, announce it — the stock info is visual
      //only, so a screen-reader user would otherwise get no feedback that the limit was reached
      this.$nextTick(() => this.announceIfOutOfStock());
    },
    announceIfOutOfStock() {
      if (!this.product) {
        return;
      }
      let name = this.services.translations.translation2Text(this.product.name);
      if (this.remainingItemsInStock !== null && this.remainingItemsInStock <= 0) {
        this.services.announcer.announce(name + ": " + this.$t("product-out-of-stock-label"));
      } else if (this.combinedSubproductHeadroom !== null && this.combinedSubproductHeadroom <= 0) {
        this.services.announcer.announce(name + ": " + this.$t("cart-item-combined-subproduct-out-of-stock-hint"));
      }
    },
    addNote() {
      this.showNote = true;
    },
    removeNote() {
      this.showNote = false;
      this.comment = "";
    },
  },
}
</script>
<style scoped>
.product-list .list-item {
  padding-bottom: 0.5rem;
  display: flex;
  margin: 1.5rem 0rem 0.5rem;
  border-bottom: 1px solid var(--ion-color-light-shade);
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.product-list .list-item:last-child {
  border-bottom: none;
}

.product-list .list-item .list-item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.product-list .list-item .list-item-name {
  font-size: 1.1rem;
  font-weight: 500;
  padding-bottom: 0em;
  margin-bottom: 0em;
  margin-top: 0;
  text-align: left;
}


.product-list .list-item .list-item-description {
  font-size: 0.9rem;
  color: var(--ion-color-dark);
  margin-top: 0.5rem;
  display: block;
}

.product-list .list-item .list-item-description::first-letter {
  text-transform: uppercase;
}

.product-list .list-item.price-quantity .list-item-price {
  font-size: 1.1rem;
  font-weight: 500;
  padding-bottom: 0.4em;
  text-align: center;
}

.product-list .list-item .list-item-actions {
  margin-left: 1rem;
}

.product-list .list-item .quantity-input {
  display: flex;
  justify-content: center;
  align-items: center;
}

.count-up-disabled-hint {
  font-size: 0.75rem;
  line-height: 1.2;
  color: var(--ion-color-danger, #db2240);
  text-align: center;
  padding-top: 0.25rem;
  max-width: 14rem;
}

.product-list .list-item .quantity-input ion-button {
  margin: 0;
  display: flex;
  align-items: center;
}

.product-list .list-item .quantity-input ion-button::part(native) {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 2rem;
  background-color: var(--ion-color-light);
  border: none;
  border: 5px solid white;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.1rem;
  font-size: 0.7rem;
  padding-bottom: 0.15rem;
}

.product-list .list-item .quantity-input .button-view.up .label {
  position: relative;
  top: 1px;
}

.product-list .list-item .quantity-input .quantity {
  font-size: 1.1rem;
  position: relative;
  bottom: 0.06rem;
  margin: 0.1rem -2px;
  min-width: 1.5rem;
  text-align: center;
}

.product-list .list-item.positive-quantity .quantity-input .quantity {
  font-weight: 500;
  color: var(--ion-color-primary);
}

.product-list .list-item.shows-total .list-item-price {
  font-size: 1rem;
  font-weight: normal;
}

.product-list .list-item.shows-total .list-item-actions.total {
  display: flex;
  align-items: center;
  margin-left: 2rem;
  justify-content: flex-end;
  min-width: 6rem;
}

.product-list .list-item.shows-total .list-item-total {
  font-size: 1.2rem;
  font-weight: 500;
}

.product-list .list-item .list-item-actions.price {}

.product-list .list-item.shows-total .list-item-actions.note.below {
  display: block;
  flex-basis: 100%;
  margin-top: 0.4rem;
  margin-left: 0rem;
  margin-bottom: 0.6rem;
}

.product-list .list-item.shows-total .list-item-actions.note textarea {
  width: 100%;
  min-height: 3rem;
}

.note-button {
  margin-left: -0.8rem;
  font-size: 0.8rem;
}

.readonly-note .note-text {
  font-size: 0.85rem;
  font-style: italic;
  text-align: left;
  margin-top: 0.2rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.3rem;
}

.tags .tag {
  border-radius: 1rem;
  font-size: 0.7rem;
  color: var(--ion-color-primary);
  padding: 0.1rem 0.4rem 0.2rem 0;
  text-align: center;
  font-weight: 599;
  margin-right: 0.3rem;
}

@media (max-width: 500px) {
  .product-list .list-item .list-item-name {
    font-size: 1rem;
  }

  .product-list .list-item.shows-total .list-item-total {
    font-size: 1rem;
  }
}


@media (max-width: 450px) {
  .product-list .list-item.shows-total .list-item-actions.total {
    flex-basis: 100%;
    margin-bottom: 0.6rem;
    margin-top: 0.9rem;
    display: flex;
   
  }
}

.combined {
  flex-basis: 100%;
  width: 100%;
  margin-left: 0 !important;
}

.combined-products .preview {
  margin-top: 0.4rem;
  margin-left: 0rem;
  margin-bottom: 1rem;
  text-align: left;
}

.combined-products .preview .slotname {
  font-weight: 500;
  font-size: 0.8rem;
  display: inline;
  text-transform: capitalize;
  display: inline-block;
}

.combined-products .preview .slotname::first-letter {
  text-transform: uppercase;
}

.combined-products .preview .product {
  display: inline-block;
  padding-left: 0.2rem;
}

.combined-products .preview .productname {
  font-size: 0.8rem;
}

.combined-products .preview .seperator.lastone {
  font-size: 0.8rem;
  display: inline-block;
  padding-left: 0.2rem;
}

.options .preview {
  margin-top: 0.4rem;
  margin-left: 0rem;
  text-align: left;
}


.options .preview .option {
  display: inline-block;
  padding-left: 0.2rem;
  font-size: 0.8rem;
}

.options .preview .optionname {
  font-weight: bold;
}

.options .preview .optionvalues .optionvalue:not(:first-child)::before {
  content: ', ';
}


.combined-products .details {
  margin-top: 2rem;
  width: 100%;
  text-align: center;
  margin-bottom: 2rem;
}

.combined-products .details .slot {
  margin-bottom: 1rem;
}

.combined-products .details .slotname {
  margin-top: 1rem;

  padding-bottom: 0.2rem;
  display: block;
  font-weight: 300;
  font-size: 1.1rem;
}

.combined-products .details .product {

  padding-left: 0.2rem;
}

.combined-products .details .productname {
  font-size: 0.8rem;
}

.combined-products .details .seperator.lastone {
  font-size: 0.8rem;
  display: inline-block;
  padding-left: 0.2rem;
}

.product-list .list-item .stock-info-container,
.product-list .list-item .manufacturing-time-container {
  font-size: 0.7rem;
  color: var(--ion-color-dark);
  margin-top: 0.2rem;
  font-weight: bold;
}

.product-list .list-item .stock-info-container .value,
.product-list .list-item .manufacturing-time-container .value {
  margin-right: 0.2rem;
  margin-left: 0.2rem;
}

.product-list .list-item .stock-info-container {
  color: var(--ion-color-dark);
}

.product-list .list-item .stock-info-container.low {
  color: var(--ion-color-warning);
}

.product-list .list-item .stock-info-container.outofstock {
  color: var(--ion-color-danger);
}

</style>
